// Mock data for Maverxx Innovations - Modern Minimalist Version

export const contactInfo = {
  phone: "9537275691",
  whatsapp: "+919537275691",
  email: "innovations@mavrexx.com",
  address: {
    name: "Mavrexx Innovations",
    line1: "F115, Samanway Westbreeze,",
    line2: "Radiyat ba marg, Nr. Tithi heights,",
    line3: "New Alkapuri, Gotri",
    city: "Vadodara - 390021",
    state: "Gujarat, India"
  }
};

export const services = [
  {
    id: 1,
    title: "Industrial FDM 3D Printing Services",
    slug: "fdm-3d-printing",
    description: "High-strength functional components engineered for mechanical performance, prototyping validation, and small-batch industrial production.",
    materials: "PLA, ABS, PETG, Nylon, Carbon-Fiber Reinforced Filaments",
    applications: "Functional testing, fit verification, production aids, mechanical assemblies",
    image: "https://images.pexels.com/photos/31336828/pexels-photo-31336828.jpeg",
    alignment: "left",
    overview: "FDM (Fused Deposition Modeling) is ideal for producing durable, dimensionally stable components suitable for real-world functional applications.\n\nAt Maverxx Innovations, we focus on mechanical integrity, material reliability, and repeatable output quality — ensuring parts perform beyond visual prototypes.\n\nWe support engineers, startups, and industrial clients requiring strong and cost-effective production-ready components.",
    useCases: [
      "Functional mechanical assemblies",
      "Jigs and fixtures",
      "Tooling aids",
      "Product housings and enclosures",
      "Brackets and mounting systems",
      "Pre-production validation runs",
      "Replacement machine parts"
    ],
    materialsGroups: [
      {
        title: "Standard Engineering Materials",
        items: [
          { name: "PLA", description: "Concept validation models" },
          { name: "ABS", description: "Impact resistance" },
          { name: "PETG", description: "Chemical resistance & durability" },
          { name: "Nylon", description: "High strength & flexibility" }
        ]
      },
      {
        title: "Advanced Materials (as applicable)",
        items: [
          { name: "Carbon-fiber reinforced filaments" },
          { name: "High-temperature materials" }
        ]
      }
    ],
    materialsDetailed: {
      "PLA": "Concept validation models",
      "ABS": "Impact resistance",
      "PETG": "Chemical resistance & durability",
      "Nylon": "High strength & flexibility",
      "Carbon-fiber reinforced filaments": "Advanced material option",
      "High-temperature materials": "Advanced material option"
    },
    industries: ["Automotive", "Manufacturing & Machinery", "Consumer Product Startups", "Industrial Equipment Suppliers", "Educational Engineering Institutions"],
    strengths: [
      "Layer adhesion optimization",
      "Tolerance-focused printing",
      "Structural integrity evaluation",
      "Controlled print environment",
      "Scalable batch production capability",
      "Material selection guidance"
    ],
    processSteps: [
      "CAD file submission",
      "Material and tolerance review",
      "Controlled print execution",
      "Inspection & finishing",
      "Secure delivery"
    ],
    ctaTitle: "Ready to Build Functional Industrial Components?",
    ctaText: "Get in touch with Maverxx Innovations to discuss your mechanical and manufacturing requirements."
  },
  {
    id: 2,
    title: "Resin 3D Printing",
    slug: "resin-3d-printing",
    description: "High-resolution resin printing for precision models and detailed components. Suitable for intricate geometries requiring smooth surface finish and dimensional accuracy.",
    applications: "Product validation models, architectural miniatures, detailed housings, dental & design prototypes",
    image: "https://images.pexels.com/photos/34367991/pexels-photo-34367991.jpeg",
    alignment: "right",
    overview: "Resin 3D printing (SLA/DLP) delivers unmatched surface quality and dimensional precision for highly detailed parts. Our high-resolution resin systems produce smooth, accurate models ideal for visual prototypes, master patterns, and functional testing.",
    useCases: [
      "High-detail visual prototypes",
      "Jewelry master patterns",
      "Dental models and surgical guides",
      "Architectural scale models",
      "Investment casting patterns",
      "Miniature components with fine features"
    ],
    materialsDetailed: {
      "Standard Resin": "General purpose, balanced properties, good surface finish",
      "Tough Resin": "ABS-like properties, high impact resistance",
      "Flexible Resin": "Rubber-like flexibility, shock absorption",
      "Castable Resin": "Clean burnout for investment casting",
      "Dental Resin": "Biocompatible, FDA-approved materials"
    },
    industries: ["Jewelry & Fashion", "Dental & Medical", "Architecture", "Product Design", "Entertainment"],
    strengths: [
      "Ultra-high resolution: 25-50 micron layer height",
      "Exceptional surface smoothness",
      "Complex geometries and fine details",
      "Isotropic mechanical properties",
      "Minimal post-processing required"
    ]
  },
  {
    id: 3,
    title: "Reverse Engineering & CAD Reconstruction Services",
    slug: "reverse-engineering",
    description: "Accurate digital recreation of physical components for replication, optimization, and industrial production.",
    capabilities: [
      "Part measurement & reconstruction",
      "CAD modeling",
      "Tolerance optimization",
      "Design enhancement for manufacturability"
    ],
    applications: "Discontinued components, legacy machinery parts, design upgrades",
    image: "https://images.unsplash.com/photo-1758873263428-f4b2edb45fe1",
    alignment: "left",
    overview: "Reverse engineering enables the transformation of existing physical parts into precise digital CAD models suitable for reproduction or improvement.\n\nAt Maverxx Innovations, we analyze, measure, and reconstruct components to restore functionality, enhance durability, or prepare for manufacturing.\n\nThis service is ideal for discontinued parts, damaged components, or legacy machinery where original design files are unavailable.",
    useCases: [
      "Legacy machine components",
      "Obsolete or discontinued parts",
      "Broken mechanical assemblies",
      "Product redesign & optimization",
      "Cost-reduction engineering",
      "Performance improvement modifications"
    ],
    materialsDetailed: {
      "Dimensional Analysis": "High-accuracy measurement and feature extraction from physical parts",
      "CAD Reconstruction": "Complete 3D modeling in industry-standard CAD formats (STEP, IGES, Parasolid)",
      "Tolerance Optimization": "Engineering analysis to refine tolerances for improved manufacturability",
      "Structural Enhancement": "Design improvements to increase strength, reduce weight, or enhance performance",
      "Material Upgrade Recommendations": "Material selection guidance based on application requirements and modern alternatives",
      "Manufacturing-Ready File Preparation": "Deliverables optimized for production processes including CNC, casting, and 3D printing"
    },
    industries: ["Automotive", "Heavy Machinery", "Industrial Equipment", "Manufacturing Plants", "Maintenance & Repair Operations"],
    strengths: [
      "Precision modeling approach with dimensional accuracy verification",
      "Engineering-first evaluation focusing on function and manufacturability",
      "Manufacturability improvement recommendations included in every project",
      "Production compatibility across multiple manufacturing processes"
    ],
    processSteps: [
      "Physical part submission and inspection",
      "Dimensional measurement and analysis",
      "CAD reconstruction and modeling",
      "Engineering review and optimization",
      "Manufacturing-ready file delivery"
    ],
    ctaTitle: "Need to Recreate or Improve an Existing Component?",
    ctaText: "Submit your part details for engineering evaluation and we'll provide a comprehensive reconstruction plan."
  },
  {
    id: 4,
    title: "Laser Cutting Services",
    slug: "laser-cutting",
    description: "Precision cutting for acrylic, MDF, and selected sheet materials. Clean edges, repeatable accuracy, and scalable production runs.",
    applications: "Panels, enclosures, branding elements, structural prototypes",
    image: "https://images.unsplash.com/photo-1759159091682-3b98f4759367",
    alignment: "right",
    overview: "Our CO2 and fiber laser cutting systems deliver precision cutting and engraving for a wide range of sheet materials. From intricate patterns to structural components, we provide clean edges, tight tolerances, and fast production.",
    useCases: [
      "Architectural models and displays",
      "Custom signage and branding",
      "Electronics enclosures",
      "Decorative panels and art installations",
      "Jigs, templates, and stencils",
      "Packaging prototypes"
    ],
    materialsDetailed: {
      "Acrylic": "Up to 20mm thickness, crystal clear edges",
      "MDF/Wood": "Up to 15mm, clean cuts, minimal charring",
      "Plywood": "Baltic birch, hardwood plywood up to 12mm",
      "Cardboard": "Corrugated and solid board for packaging",
      "Fabric": "Textiles, felt, leather (non-PVC)"
    },
    industries: ["Architecture", "Retail Display", "Electronics", "Signage", "Packaging", "Art & Design"],
    strengths: [
      "Cutting area: 1300 x 900mm",
      "Precision: ±0.1mm positioning accuracy",
      "Edge quality: Flame-polished acrylic edges",
      "Fast turnaround: Same-day service available",
      "Vector file support: AI, DXF, SVG, PDF"
    ]
  },
  {
    id: 5,
    title: "Rapid Product Prototyping",
    slug: "rapid-prototyping",
    description: "End-to-end rapid prototyping services from concept to functional prototype. Multi-process approach combining 3D printing, CNC machining, and finishing for production-ready models.",
    applications: "Product development, investor presentations, design validation, crowdfunding campaigns",
    image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800",
    alignment: "left",
    overview: "Our rapid prototyping service accelerates product development by combining multiple manufacturing processes. We deliver functional, aesthetically refined prototypes that look and perform like final production units—perfect for testing, validation, and investor presentations.",
    useCases: [
      "Product design validation",
      "Functional testing and user trials",
      "Investor and crowdfunding campaigns",
      "Trade show and exhibition models",
      "Design iteration and optimization",
      "Pre-production pilot runs"
    ],
    materialsDetailed: {
      "Multi-Process": "3D printing + CNC machining + finishing",
      "Surface Finishing": "Sanding, painting, vapor smoothing, anodizing",
      "Assembly": "Multi-part assembly with fasteners and adhesives",
      "Electronics Integration": "Embed LEDs, sensors, and functional electronics"
    },
    industries: ["Consumer Electronics", "IoT Devices", "Wearables", "Home Appliances", "Toys & Games", "Startups"],
    strengths: [
      "Production-quality surface finish",
      "Multi-material and multi-color prototypes",
      "Functional electronics integration",
      "Fast iteration: 3-5 day turnaround",
      "Design-for-manufacturing feedback included"
    ]
  }
];

export const industries = [
  {
    id: 1,
    title: "Engineering & Startup Prototypes",
    description: "Rapid iteration for innovators and product developers.",
    features: [
      "Functional prototypes",
      "Iterative product testing",
      "Small batch validation runs",
      "Confidential development under NDA"
    ],
    tagline: "We help startups move from idea to investor-ready product models.",
    image: "https://images.unsplash.com/photo-1769147339214-076740872485"
  },
  {
    id: 2,
    title: "Industrial Manufacturing Partnerships",
    description: "Reliable manufacturing support for industrial clients.",
    features: [
      "Production-grade parts",
      "Repeatable tolerances",
      "Long-term supply capability",
      "Process-driven execution"
    ],
    tagline: "Built for factories, OEM suppliers, and production environments.",
    image: "https://images.pexels.com/photos/33559451/pexels-photo-33559451.jpeg"
  }
];

export const processSteps = [
  {
    id: 1,
    number: "01",
    title: "Design Submission",
    description: "Share CAD file or physical sample."
  },
  {
    id: 2,
    number: "02",
    title: "Technical Review",
    description: "We evaluate manufacturability and material suitability."
  },
  {
    id: 3,
    number: "03",
    title: "Production & Quality Check",
    description: "Controlled printing and inspection."
  },
  {
    id: 4,
    number: "04",
    title: "Delivery",
    description: "On-time dispatch with performance confidence."
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Automotive Engine Component",
    category: "FDM Printing",
    description: "High-strength functional prototype for automotive testing",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800",
    size: "large"
  },
  {
    id: 2,
    title: "Medical Device Housing",
    category: "Resin Printing",
    description: "Precision housing with smooth finish for medical equipment",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800",
    size: "medium"
  },
  {
    id: 3,
    title: "Mechanical Assembly Jig",
    category: "FDM Printing",
    description: "Custom jig for production line assembly",
    image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800",
    size: "medium"
  },
  {
    id: 4,
    title: "Legacy Part Reconstruction",
    category: "Reverse Engineering",
    description: "CAD reconstruction of discontinued machinery component",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800",
    size: "large"
  },
  {
    id: 5,
    title: "Acrylic Display Panel",
    category: "Laser Cutting",
    description: "Precision-cut branding display with clean edges",
    image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=800",
    size: "medium"
  },
  {
    id: 6,
    title: "Industrial Control Enclosure",
    category: "FDM Printing",
    description: "Durable enclosure for industrial control systems",
    image: "https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?w=800",
    size: "medium"
  }
];

export const whyChooseUs = [
  "Tight dimensional tolerance control",
  "Engineering-focused approach",
  "Fast turnaround timelines",
  "Transparent communication",
  "Scalable from prototype to production",
  "Confidential & professional handling"
];

export const heroImages = [
  "https://images.unsplash.com/photo-1738305992246-1c7fcdb80f38",
  "https://images.pexels.com/photos/30640195/pexels-photo-30640195.jpeg",
  "https://images.unsplash.com/photo-1603974739172-4ad6a3117e40"
];

export const navLinks = [
  { name: "Home", href: "#home" },
  { name: "Services", href: "#services" },
  { name: "Engineering", href: "#engineering" },
  { name: "Industrial", href: "#industrial" },
  { name: "Portfolio", href: "#portfolio" },
  { name: "Contact", href: "#contact" }
];
